<template>
  <v-menu
    v-model="datetimeOpen"
    :max-width="width"
    :min-width="width"
    :close-on-content-click="false"
    content-class="UXDatapicker"
    :disabled="disabled"
  >
    <template v-slot:activator="{ on }">
      <div class="UXdateInput" v-on="on" :class="{ disabled: disabled }">
        <span class="inpTxt" v-if="picker !== ' '">{{ picker }}</span>
        <span class="inpTxt" v-else>0000-00-00 ~ 0000-00-00</span>
        <i class="UXicon-calendar"></i>
      </div>
    </template>

    <v-card class="UXdtpCard">
      <div class="head">
        <p>
          <strong v-if="calendarData.dateRange"
            >{{ isDateOut(calendarData.dateRange.start) }} ~
            {{ calendarData.dateRange.end ? isDateOut(calendarData.dateRange.end) : '날짜선택' }}</strong
          >
          <strong v-else>날짜선택</strong>
        </p>
        <div class="endBtn" v-if="picker && calendarData.dateRange && calendarData.dateRange.end">
          <v-btn v-if="showCompleteBtn" dark color="#5578F0" @click="setDataTime"> 완료 </v-btn>
        </div>
      </div>
      <div class="con">
        <FunctionalCalendar ref="funCalendar" v-model="calendarData" :configs="calendarConfigs" v-on:choseDay="clickDay"></FunctionalCalendar>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { FunctionalCalendar } from 'vue-functional-calendar';
import moment from 'moment';

export default {
  name: 'datePicker',
  components: {
    FunctionalCalendar
  },
  data() {
    return {
      calendarData: {},
      calendarConfigs: {
        sundayStart: true,
        isDateRange: true,
        isMultiple: true,
        calendarsCount: this.calendarsCount,
        hiddenElements: ['leftAndRightDays'],
        dateFormat: 'yyyy-mm-dd',
        dayNames: ['월', '화', '수', '목', '금', '토', '일'],
        monthNames: ['.01', '.02', '.03', '.04', '.05', '.06', '.07', '.08', '.09', '.10', '.11', '.12'],
        disabledDates: this.disabledDates,
        markedDateRange: {
          start: '',
          end: ''
        },
        limits: this.limits,
        maxSelDays: this.maxSelDays,
        enabledDates: this.enabledDates
      },
      datetimeOpen: false,
      picker: ''
    };
  },
  props: {
    startDate: {
      type: String
    },
    endDate: {
      type: String
    },
    disabledDates: {
      type: Array
    },
    disabled: {
      type: Boolean
    },
    limits: {
      type: [Boolean, Object]
    },
    maxSelDays: {
      type: [Boolean, Number]
    },
    calendarsCount: {
      type: Number,
      default: () => 2
    },
    isWeekSelect: {
      // 주단위 선택일 때 사용 옵션
      type: Boolean,
      default: () => false
    },
    width: {
      // 캘린더 팝업 가로길이
      type: Number,
      default: () => 520
    },
    showCompleteBtn: {
      // 완료버튼 노출여부 값
      type: Boolean,
      default: () => true
    },
    enabledDates: {
      type: Array
    }
  },
  watch: {
    startDate() {
      this.changeDate();
    },
    endDate() {
      this.changeDate();
    },
    datetimeOpen() {
      let fromDate = this.startDate ? this.startDate : moment().format('YYYY-MM-DD');
      let toDate = this.endDate ? this.endDate : moment().format('YYYY-MM-DD');

      setTimeout(() => {
        this.calendarData.dateRange.start = this.isDateIn(fromDate);
        this.calendarData.dateRange.end = this.isDateIn(toDate);
      });
      this.$refs.funCalendar.ChooseDate(this.isDateIn(fromDate));
    }
  },
  created() {
    if (!this.startDate && !this.endDate) {
      this.picker = ' ';
    } else {
      this.picker = this.isDateOut(this.startDate) + ' ~ ' + this.isDateOut(this.endDate);
    }
  },

  methods: {
    clickDay(val) {
      if (this.isWeekSelect) {
        const _today = moment(new Date());
        const date = moment(new Date(this.isDateIn(val.date)));
        const compareDate = _today.diff(date, 'days') < 7;
        const _getDay = date.day() === 0 ? '7' : date.day();
        const startDate = moment(date)
          .subtract(_getDay - 1, 'days')
          .format('YYYY-MM-DD');
        let endDate = compareDate
          ? moment(_today).format('YYYY-MM-DD')
          : moment(date)
              .add(7 - _getDay, 'days')
              .format('YYYY-MM-DD');

        let datePicker = {
          start: this.isDateOut(startDate),
          end: this.isDateOut(endDate)
        };
        this.picker = datePicker.start + ' ~ ' + datePicker.end;
        setTimeout(() => {
          this.calendarData.dateRange.start = this.isDateIn(startDate);
          this.calendarData.dateRange.end = this.isDateIn(endDate);
        });
        this.$emit('child', datePicker);
        this.datetimeOpen = false;
      }
    },
    isDateIn(val) {
      if (val) {
        let date = val.split('-').map((k) => (k.toString()[0] === '0' ? k.replace('0', '') : k));
        return date[0] + '-' + date[1] + '-' + date[2];
      }
    },
    isDateOut(val) {
      if (val) {
        let date = val.split('-').map((k) => (k.toString().length === 1 ? '0' + k : k));
        if (date[1] === '00') date[1] = '01';
        return date[0] + '-' + date[1] + '-' + date[2];
      }
    },
    changeDate() {
      this.$refs.funCalendar.dateRangeSelectedStartDate = this.startDate;
      this.$refs.funCalendar.dateRangeSelectedEndDate = this.endDate;
      if (!this.startDate && !this.endDate) {
        this.picker = ' ';
      } else {
        this.picker = this.startDate + ' ~ ' + this.endDate;
      }
    },
    setDataTime() {
      try {
        if (this.calendarData.dateRange) {
          let datePicker = {
            start: this.isDateOut(this.calendarData.dateRange.start),
            end: this.isDateOut(this.calendarData.dateRange.end)
          };
          this.picker = datePicker.start + ' ~ ' + datePicker.end;
          this.$emit('child', datePicker);
        }
        this.datetimeOpen = false;
      } catch (e) {
        console.log(e);
      }
    },
    getDay(date) {
      const daysOfWeek = ['월', '화', '수', '목', '금', '토', '일'];
      return daysOfWeek[new Date(date).getDay(date)];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DatePicker.vue